import { useMutation } from 'react-query'
import request from '../request'

export const useEditUploadById = () => {
  return useMutation(
    ({
      upload_id,
      upload_data,
    }: {
      upload_id: number
      upload_data: Record<string, string | number>
    }) => {
      return request({
        url: `/uploads/${upload_id}`,
        method: 'PATCH',
        data: upload_data,
      })
    },
  )
}
